import { ref } from 'vue'
import { AxiosInstance } from 'axios'
import { getCommonAnalytics } from '/@src/api/adminRepo'

export default function useCommonStat(api: AxiosInstance) {
  const response = ref<DashboardCommonAnalytics>()
  const getDashboardAnalytics = async () => {
    const ret = await getCommonAnalytics(api)
    response.value = ret
  }
  return {
    response,
    getDashboardAnalytics,
  }
}
